import Facet from "../types/funnelback/Facets";

const dateRangeValueTemplate = {
    data: "",
    label: "",
    count: 0,
    queryStringParam: "",
    constraint: "",
    selected: false,
    queryStringParamName: "",
    queryStringParamValue: "",
    toggleUrl: "",
};

const dateRangeFacetTemplate: Facet = {
    name: "",
    unselectAllUrl: "",
    selectionType: "SINGLE",
    constraintJoin: "AND",
    order: [""],
    facetValues: "",
    guessedDisplayType: "DATE_RANGE",
    categories: [],
    customData: {},
    allValues: [],
    selectedValues: [],
    selected: false,
};

const receivedDateStartFacet: Facet = {
    ...dateRangeFacetTemplate,
    name: "Date received__start",
    categories: [
        {
            queryStringParamName:
                "ge_applicationReceivedDateFB|dateReceived__start",
            values: [{ ...dateRangeValueTemplate }],
        },
    ],
};

const receivedDateEndFacet: Facet = {
    ...dateRangeFacetTemplate,
    name: "Date received__end",
    categories: [
        {
            queryStringParamName:
                "le_applicationReceivedDateFB|dateReceived__end",
            values: [{ ...dateRangeValueTemplate }],
        },
    ],
};

const decisionDateStartFacet: Facet = {
    ...dateRangeFacetTemplate,
    name: "Date of decision__start",
    categories: [
        {
            queryStringParamName:
                "ge_determinationdateOfDecisionFB|dateDecision__start",
            values: [{ ...dateRangeValueTemplate }],
        },
    ],
};

const decisionDateEndFacet: Facet = {
    ...dateRangeFacetTemplate,
    name: "Decision date__start",
    categories: [
        {
            queryStringParamName:
                "le_determinationdateOfDecisionFB|dateDecision__end",
            values: [{ ...dateRangeValueTemplate }],
        },
    ],
};

// EES projects and referrals collection ie delwp-search-listings-ees-push
const referralDateStartFacet: Facet = {
    ...dateRangeFacetTemplate,
    name: "Date range (Referral accepted)__start",
    categories: [
        {
            queryStringParamName:
                "ge_referralAcceptedDateFilter|dateDecision__start",
            values: [{ ...dateRangeValueTemplate }],
        },
    ],
};

const referralDateEndFacet: Facet = {
    ...dateRangeFacetTemplate,
    name: "Date range (Referral accepted)__end",
    categories: [
        {
            queryStringParamName:
                "le_referralAcceptedDateFilter|dateDecision__end",
            values: [{ ...dateRangeValueTemplate }],
        },
    ],
};

const resolveFacets = (
    facets: Facet[] | undefined,
    collection: string
): Facet[] => {
    if (
        facets &&
        [
            "delwp-planning-ministerial-permits-stage",
            "delwp-planning-ministerial-permits-prod",
        ].includes(collection)
    ) {
        const newFacets: Facet[] = [];

        for (const facet of facets) {
            if (facet.guessedDisplayType === "CHECKBOX") {
                newFacets.push(
                    receivedDateStartFacet,
                    receivedDateEndFacet,
                    decisionDateStartFacet,
                    decisionDateEndFacet
                );
            }
            newFacets.push(facet);
        }
        // Define the desired order of names
        const desiredOrder = [
            "Decision",
            "Date of decision__start",
            "Decision date__start",
            "Type",
            "Date received__start",
            "Date received__end",
            "Status",
            "dfp",
        ];

        // Create a mapping of names to their original positions
        const nameToPosition: Record<string, number> = {};
        newFacets.forEach((item, index) => {
            nameToPosition[item.name] = index;
        });

        // Sort the data based on the desired order
        const rearrangedData = desiredOrder
            .map((name) => nameToPosition[name])
            .filter((index) => index !== undefined && index !== null)
            .map((index) => newFacets[index]);

        return rearrangedData;
    }

    // EES projects and referrals collection ie delwp-search-listings-ees-push
    if (
        facets &&
        [
            "delwp-search-listings-ees-push-stage",
            "delwp-search-listings-ees-push",
        ].includes(collection)
    ) {
        const newFacets: Facet[] = [];

        for (const facet of facets) {
            if (facet.guessedDisplayType === "CHECKBOX") {
                newFacets.push(referralDateStartFacet, referralDateEndFacet);
            }
            newFacets.push(facet);
        }
        // Define the desired order of names
        const desiredOrder: string[] = [
            "Assessment type",
            "Status",
            "Council",
            "Type",
            "Date range (Referral accepted)__start",
            "Date range (Referral accepted)__end",
            "Show accredited assessments",
        ];

        // Create a mapping of names to their original positions
        const nameToPosition: Record<string, number> = {};
        newFacets.forEach((item, index) => {
            nameToPosition[item.name] = index;
        });

        // Sort the data based on the desired order
        const rearrangedData = desiredOrder
            .map((name) => nameToPosition[name])
            .filter((index) => index !== undefined && index !== null)
            .map((index) => newFacets[index]);

        return rearrangedData;
    }

    return facets || [];
};

export default resolveFacets;
